import { ErrorMessage, Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button } from 'semantic-ui-react';
import MyTextInput from '../../app/common/form/MyTextInput';
import { useStore } from '../../app/stores/store';
import * as Yup from 'yup';
import ValidationErrors from '../Errors/ValidationErrors';
import { useEffect, useRef, useState, CSSProperties } from 'react';
import MySelectInput from '../../app/common/form/MySelectInput';
import { useNavigate } from 'react-router-dom';

export default observer(function LoginForm() {
  const {
    userStore: { listOfTenants, login, tenantNames },
  } = useStore();
  const history = useNavigate();
  const [emailId, setEmailId] = useState('');
  const showTenants = useRef(false);
  const selectOptions: any = useRef({
    key: '',
    text: '',
    value: '',
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      if (emailId) listOfTenants(emailId);
    }, 700);
    return () => clearTimeout(timer);
  }, [listOfTenants, emailId]);

  if (tenantNames.length > 1) {
    selectOptions.current = tenantNames.map((name) => ({
      key: name,
      text: name,
      value: name,
    }));
    showTenants.current = true;
  } else {
    showTenants.current = false;
  }

  const selectDropdownStyles: CSSProperties = {
    borderColor: '#e5dfa1',
    boxShadow: '0 0 0 100px ivory inset',
  };

  return (
    <Formik
      initialValues={{
        email: '',
        id: '',
        password: '',
        error: null,
        newPassword: '',
        image: '',
        fullName: '',
        customerName: '',
        departmentName: '',
        addressLine1: '',
        addressLine2: '',
        country: '',
        state: '',
        city: '',
        postalCode: '',
        alternatePhoneNumber: '',
        remarks: '',
        role: '',
        workPosition: '',
        superior: '',
        website: '',
        workDepartment: '',
        workApplicationsKnown: '',
        languagesKnown: '',
        roleId: '',
        isAdmin: false,
        isDeleted: false,
      }}
      onSubmit={(values, { setErrors, setSubmitting }) => {
        login(values.email, values.password, values.customerName, () =>
          history('/mediaAssets'),
        ).catch(() => setErrors({ error: 'Invalid Credentials' }));
        setSubmitting(false);
      }}
      validationSchema={Yup.object({
        email: Yup.string().required().email(),
        password: Yup.string().required(),
      })}
    >
      {({
        handleSubmit,
        isSubmitting,
        errors,
        isValid,
        dirty,
        values,
        setFieldValue,
      }) => (
        <Form
          className="ui form"
          onSubmit={handleSubmit}
          autoComplete="off"
          style={{ width: '500px' }}
        >
          <MyTextInput
            name="email"
            placeholder="Email"
            onBlur={() => setEmailId(values.email)}
          />
          <MyTextInput name="password" placeholder="Password" type="password" />
          {showTenants.current ? (
            <MySelectInput
              name="customerName"
              placeholder="Tenant"
              options={selectOptions.current}
              customStyle={selectDropdownStyles}
            />
          ) : (
            <input type="hidden" value="" name="customerName" />
          )}
          <ErrorMessage
            name="error"
            render={() => <ValidationErrors errors={errors.error} />}
          />
          <br />
          {/* <Checkbox label='Remember me' style={{ marginBottom: '10pt' }} /> */}
          <Button
            disabled={
              !isValid || !dirty || isSubmitting || tenantNames.length === 0
            }
            loading={isSubmitting}
            onClick={
              showTenants.current
                ? undefined
                : () => setFieldValue('customerName', tenantNames[0])
            }
            positive
            content="Login"
            type="submit"
            fluid
          />
        </Form>
      )}
    </Formik>
  );
});
